var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0439 3.75H4.54395C4.14612 3.75 3.76459 3.90804 3.48329 4.18934C3.20198 4.47064 3.04395 4.85218 3.04395 5.25V18.75C3.04395 19.1478 3.20198 19.5294 3.48329 19.8107C3.76459 20.092 4.14612 20.25 4.54395 20.25H21.0439C21.4418 20.25 21.8233 20.092 22.1046 19.8107C22.3859 19.5294 22.5439 19.1478 22.5439 18.75V5.25C22.5439 4.85218 22.3859 4.47064 22.1046 4.18934C21.8233 3.90804 21.4418 3.75 21.0439 3.75ZM4.54395 5.25H8.29395V18.75H4.54395V5.25ZM21.0439 18.75H9.79395V5.25H21.0439V18.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon);
export default __webpack_public_path__ + "static/media/sidebarIcon.6d24b9a1e25875d95caebbcd0874683b.svg";
export { ForwardRef as ReactComponent };